<div class="maps-container">
  <div #mapContainer id="map"></div>
</div>
